import { getUserGoal } from './service/GoalService';
import { getUser } from './service/AuthService'


import React from 'react';

const Home = () => {
    //console.log('getting user goal');
    //console.log(getUserGoal());

    let goal = getUserGoal();
    let user = getUser().name;
    return (
        <div>
            <div>
                <h3> Congratulations on finishing your Daily Workout!</h3>
                <br></br>
                <h4> {user}: We are working towards -- (insert SMART goal here) </h4>
                <br></br>
                The goal for today is: {goal.textcontent}
            </div>
            <div>
                <br></br>
                <p>here add some metrics on how the current usage is attributing towards goal / how on track you are for dailiy goal</p>
            </div>
        </div>
    )
}


export default Home;